export default __webpack_public_path__ + "static/media/mountains.359696bd66df36ee098aa91183006c28.jpg";